<template>
	<div class="layout mx-auto">
		<div class="flex flex-col h-screen">
			<header>
				<div class="mx-auto pb-6 pt-10">
					<img
						class="logo"
						src="../../assets/static/svg/joinme.svg"
						alt=""
						srcset=""
					/>
				</div>
				<div class="mx-6 my-6 text-navyBlue">
					<h3>
						<h1 class="text-3xl">
							Daftar Akun <b class="text-lightPurple">Gratis</b>
						</h1>
					</h3>
					<p class="text-center mt-3 leading-tight">
						Daftar akun gratis selamanya dan nikmati berbagai macam fitur yang
						tersedia.
					</p>
				</div>
			</header>
			<main class="mb-auto">
				<form class="login mx-6 text-navyBlue" @submit.prevent="register">
					<div class="text-left pt-3 pb-6">
						<p
							v-if="error.message"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							<b>Info:</b> Server Error - {{ error.message }}
						</p>
						<label class="text-left">Name</label><br />
						<input
							class="px-3 py-2 mt-1 outline-none w-full mb-3"
							required
							v-model="name"
							type="text"
							placeholder="Name"
						/>
						<p
							v-if="error.info.name"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							{{ error.info.name }}
						</p>
						<label class="text-left">Phone</label>
						<input
							class="px-3 py-2 mt-1 outline-none w-full mb-3"
							required
							v-model="phone"
							type="text"
							placeholder="Phone"
						/>
						<p
							v-if="error.info.phone"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							{{ error.info.phone }}
						</p>
						<label class="text-left">Email</label><br />
						<input
							class="px-3 py-2 mt-1 outline-none w-full mb-3"
							required
							v-model="email"
							type="text"
							placeholder="Email"
						/>
						<p
							v-if="error.info.email"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							{{ error.info.email }}
						</p>
						<label class="text-left">Password</label>
						<div class="inset-y-0 right-0 flex items-center ">
							<input
								class="px-3 py-2 mt-1 outline-none mb-3"
								required
								v-model="password"
								:type="showPass ? 'text' : 'password'"
								placeholder="********"
							/>
							<img
								@click="showPassword"
								v-if="showPass"
								class="eye"
								src="../../assets/static/svg/eye-open.svg"
								alt=""
								srcset=""
							/>
							<img
								v-if="!showPass"
								@click="showPassword"
								class="eye"
								src="../../assets/static/svg/eye-close.svg"
								alt=""
								srcset=""
							/>
						</div>
						<p
							v-if="error.info.password"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							{{ error.info.password }}
						</p>
						<label class="text-left">Confirm Password</label>
						<div class="inset-y-0 right-0 flex items-center ">
							<input
								class="px-3 py-2 mt-1 outline-none mb-3"
								required
								v-model="confirmPassword"
								:type="showPass ? 'text' : 'password'"
								placeholder="********"
							/>
							<img
								@click="showPassword"
								v-if="showPass"
								class="eye"
								src="../../assets/static/svg/eye-open.svg"
								alt=""
								srcset=""
							/>
							<img
								v-if="!showPass"
								@click="showPassword"
								class="eye"
								src="../../assets/static/svg/eye-close.svg"
								alt=""
								srcset=""
							/>
						</div>
						<p
							v-if="error.info.confirmPassword"
							class="mb-2 w-full px-2 -mt-2 text-left text-red-700 bg-red-300"
						>
							{{ error.info.confirmPassword }}
						</p>
					</div>
					<div></div>
					<button
						class="button-login outline-none focus:outline-none bg-lightPurple text-white w-full py-2 uppercase font-bold rounded-sm "
						type="submit"
					>
						<span class="button-login">{{
							authStatus ? authStatus : "Daftar"
						}}</span>
					</button>
				</form>
				<div class="text-center pt-3 pb-6">
					<p class="text-md text-navyBlue">
						Sudah punya akun ?
						<router-link to="/login" class="font-bold">Login</router-link>
					</p>
				</div>
			</main>
			<footer>
				<div class=" mb-0 pb-0 h-full">
					<p class=" bg-navyBlue py-2 text-sm text-whiteBase">
						©2021 joinme.id | All Right Reserved
					</p>
				</div>
			</footer>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			name: "",
			phone: "",
			email: "",
			password: "",
			confirmPassword: "",
			showPass: false,
			error: {
				message: "",
				info: {
					name: "",
					phone: "",
					email: "",
					password: "",
					confirmPassword: "",
				},
			},
		};
	},
	computed: {
		authStatus: function() {
			return this.$store.getters.authStatus;
		},
	},
	methods: {
		resetError: function resetError() {
			this.error.info.name = "";
			this.error.info.phone = "";
			this.error.info.email = "";
			this.error.info.password = "";
			this.error.info.confirmPassword = "";
			this.error.message = "";
		},
		showPassword: function() {
			this.showPass = !this.showPass;
		},
		register: function() {
			//reset error value
			this.resetError();
			//validation password
			if (this.password != this.confirmPassword) {
				this.error.info.confirmPassword =
					"Confirm password must same with password";
				return;
			}
			//set data variable
			let data = {
				name: this.name,
				phone: this.phone,
				email: this.email,
				password: this.password,
			};
			//make request to actions
			this.$store
				.dispatch("register", data)
				.then(() => {
					this.$router.push("/");
				})
				.catch((err) => {
					if (err.response.status < 201 || err.response.status == 400) {
						//setting response error if any
						if (err.response.data.error.info.name) {
							this.error.info.name = err.response.data.error.info.name;
						}
						if (err.response.data.error.info.phone) {
							this.error.info.phone = err.response.data.error.info.phone;
						}
						if (err.response.data.error.info.email) {
							this.error.info.email = err.response.data.error.info.email;
						}
						if (err.response.data.error.info.password) {
							this.error.info.password = err.response.data.error.info.password;
						}
						return;
					} else {
						this.error.message = "unknown error";
						return;
					}
				});
		},
	},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span {
	font-family: "Karla", sans-serif;
}
.logo {
	max-width: 200px;
	height: auto;
	margin: 0 auto;
}
input[type="text"],
input[type="text"]:active,
input[type="text"]:focus,
input[type="text"]:hover,
input[type="password"],
input[type="password"]:active,
input[type="password"]:focus,
input[type="password"]:hover {
	border: 1px solid rgb(131, 131, 131);
	width: 100%;
	background-color: transparent;
}
.button-login {
	letter-spacing: 6px !important;
	font-weight: bold;
	font-size: 19px;
}
.eye {
	position: relative;
	margin-left: -30px;
	cursor: pointer;
}
.info {
	position: relative;
	cursor: pointer;
	max-width: 23px;
	height: auto;
}
</style>
